/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/no-unresolved
import interactive_report from './interactive_report';

export default function Gims() {
  return <interactive_report />;
}
